import { CommonButton2 } from "components/CommonUI";
import { Layout } from "components2";
import { ALink, BackButton2, DataLabel, Disclaimer2, NextButton2, StepperBar, SummaryTitle, Dialog } from "components2/CommonUI";
import { CREATE_BOOKING_STATUS, UPDATE_BOOKING_STATUS } from "constants/o2Appointment";
import { O2APPOINTMENT_ENTRY, O2APPOINTMENT_INFO, O2CONTACT_DETAIL } from "constants/route";
import { useAdobeDigitalData, useWogaa } from "hooks";
import { useRef } from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { createAppointment, updateAppointment  } from "services/api-service2";
import { AppointmentDetail, CustomerDetail, EnquiryDetail } from "./o2AppointmentReviewComponents";

// Will reset the inputs if come back from next page
export default function O2AppointmentReview() {
  const [agree, setAgree] = useState(false);
  const navigate = useNavigate();
  const {
    bookingTxnId 
  } = useSelector((state) => state.o2Appointment);
  const { isLogin } = useSelector((state) => state.signPassIdentify);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const refTermsDialog = useRef();
  useAdobeDigitalData({name: "APPOINTMENT_REVIEW", path:"/appointment-review"});

  useEffect(() => {
    // appointment-entry page has long content, scroll to top when enter this page
    document.body.scrollTo({ top: 0 });

    return () => {};
  }, []);

  const [stepperItems, setStepperItems] = useState([
    { text: "Appointment details", current: false, complete: true, link: O2APPOINTMENT_ENTRY },
    { text: "Contact details", current: false, complete: true, link: O2CONTACT_DETAIL },
    { text: "Review", current: true, complete: false }
  ]);

  const clkBack = () => {
    navigate(O2CONTACT_DETAIL);
  };

  const clkNext = async () => {
    if(loading) {
      return;
    }
    setLoading(true);

    if(bookingTxnId === null) {
      // call save api
      const result = await createAppointment();
      if(result === CREATE_BOOKING_STATUS.OK) {
        navigate(O2APPOINTMENT_INFO);
      }
    } else {
      // call update api
      const result = await updateAppointment();
      if(result === UPDATE_BOOKING_STATUS.OK) {
        navigate(O2APPOINTMENT_INFO);
      }
    }
    
    setLoading(false);
    console.log("**next");
  };

  return (
    <Layout
      subHeader={"Book an appointment"}
      mainText={
        <StepperBar
          title={<span style={{ whiteSpace: "normal" }}>Book an appointment</span>}
          items={stepperItems}
        />
      }>

      <div>
        <div className="form-box--plain">
          <div className={"px-1 px-3 pt-64 md-pt-48 sm-pt-48 sm-mb-32 md-mb-32 lg-mb-23 xl-mb-24"}>
            <h4 className={"text-center sm-mb-32 md-mb-32 lg-mb-48 xl-mb-48 lg-fs-32 xl-fs-32"}>Review appointment booking</h4>
            <CustomerDetail />
            <EnquiryDetail />
            <AppointmentDetail />
            <Disclaimer2 onChange={()=>{
              setAgree(!agree);
            }}
              text={<>I have read and agreed to the <ALink onClick={(e)=>{
                e.preventDefault();
                refTermsDialog.current.show();
              }}>Terms and Conditions</ALink>.</>}
              checked={agree} />
          </div>

          <div className="form-footer" stle={{marginTop:0}}>
            <div
              className={
                "w-100 d-flex flex-column-reverse flex-md-row justify-content-between px-md-3 py-2 align-items-start "
              }>
              <div className={"mobile-w-100"}>
                <BackButton2 onClick={clkBack} />
              </div>
              <div className={"mb-3 mb-md-0 mobile-w-100"}>
                <NextButton2 text={"Submit"} disabled={!agree} onClick={clkNext} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Dialog ref={refTermsDialog} header={"Terms and Conditions"}  >
        <div style={{display:"flex"}}>
          <div style={{fontWeight:600, marginRight: 10}}>1</div>
          <div>Welcome to CPF Appointment Service (“System”), a service brought to you by the Central Provident Fund Board (“CPFB”). This System is owned and maintained by the CPFB.</div>
        </div>
        <div style={{display:"flex", marginTop: 15}}>
          <div style={{fontWeight:600, marginRight: 10}}>2</div>
          <div>The System is available for use 24/7.</div>
        </div>
        <div style={{display:"flex", marginTop: 15}}>
          <div style={{fontWeight:600, marginRight: 10}}>3</div>
          <div>CPFB reserves the right to shut down the System for system maintenance as and when necessary. CPFB shall take reasonable steps to notify the customer of the system unavailability by posting a message broadcast on the CPFB Website.</div>
        </div>
        <div style={{display:"flex", marginTop: 15}}>
          <div style={{fontWeight:600, marginRight: 10}}>4</div>
          <div>Appointment slots are subject to availability.</div>
        </div>
        <div style={{display:"flex", marginTop: 15}}>
          <div style={{fontWeight:600, marginRight: 10}}>5</div>
          <div>One customer per appointment slot.</div>
        </div>
      </Dialog>
      {/*<Dialog ref={refErrorDialog} header={error.header} footer={
        <CommonButton2 text={"OK"} leftOrRight={"right"} onClick={() => dispatch(updateError(null))} />
      }>
        {error.message}
      </Dialog>*/}
    </Layout>
  );
}
